import { Actions } from "vuex-smart-module";
import axios from "@/web_client/axios_config";
import getCookie from "@/utils/get_cookie";
import router from "@/router";

import { IToken, IUserLogin, ITokenStatus } from "./models";
import AuthState from "./state";
import AuthMutations from "./mutations";
import AuthGetters from "./getters";
import Urls from "@/web_client/urls";
import { MutationTypes } from "../mutations-types";
import { user } from "@/store";

const authUrl = Urls.authUrls;

export default class AuthActions extends Actions<
  AuthState,
  AuthGetters,
  AuthMutations,
  AuthActions
> {
  csrfTokenRequest() {
    axios
      .get(authUrl.crsfUrl)
      .then(() => {
        axios.defaults.headers.common["X-CSRFToken"] = getCookie("csrftoken");
        this.commit(MutationTypes.CSRF_TOKEN_SET);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  authRequest(user: IUserLogin) {
    this.commit(MutationTypes.AUTH_REQUEST);
    axios
      .post(authUrl.loginUrl, user)
      .then(() => {
        localStorage.setItem("auth-status", "success"); // Guarda el status en LocalStorage
        this.commit(MutationTypes.AUTH_SUCCESS);
        this.dispatch("confirmActiveToken");
      })
      .catch((err) => {
        this.commit(MutationTypes.AUTH_ERROR, err.response.status);
        localStorage.removeItem("auth-status");
      });
  }

  confirmActiveToken() {
    axios
      .get<ITokenStatus>(authUrl.validateUrl)
      .then((resp) => {
        this.commit(MutationTypes.TOKEN_LOADED, true);
        this.commit(MutationTypes.TOKEN_STATUS, resp.data);
        if (resp.data.has_token) {
          this.commit(MutationTypes.HAS_TOKEN);
        } else {
          //Desloggea al usuario del server
          this.dispatch("authLogout");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  sendToken(token: IToken) {
    axios
      .post(authUrl.validateUrl, token)
      .then(() => {
        this.commit(MutationTypes.VALIDATE_SUCCESS);
        // Obtener información de usuario
        user.dispatch("userRequest");
      })
      .catch((err) => {
        this.commit(MutationTypes.VALIDATE_ERROR, err.response.status);
      });
  }

  authLogout() {
    axios.post(authUrl.logoutUrl).then(() => {
      this.commit(MutationTypes.AUTH_LOGOUT);
      this.commit(MutationTypes.TOKEN_LOADED, false);
      user.commit(MutationTypes.USER_LOGOUT);
      localStorage.removeItem("auth-status");
      //Manda al usuario a login si no se encuentra ahí
      if (router.currentRoute.path != "/login") {
        router.push("/login");
      }
    });
  }
}
